import { Link, useNavigate } from "react-router-dom";
import {
    mobiledev,
    onlinestores,
    uxuidesign,
    webappdev,
} from "../../../../assets";
import "./Footer.css";
import { CustomButton } from "../../../../components";
import { Fragment } from "react";

const Footer = () => {
    const navigate = useNavigate();
    return (
        <div className="footer">
            <div className="left-side">
                <div className="project-type">
                    <h2>
                        Looking for a <br />
                        specific project <br />
                        type?
                    </h2>
                </div>
                <div className="all-projects-link">
                    <CustomButton
                        onClick={() => {
                            window.scrollTo(0, 0);
                            navigate("/catalog");
                        }}
                        vAlignment='flex-end'
                        content={<Fragment>Want to see<br/> <strong>ALL PROJECTS?</strong></Fragment>}
                        direction={"right"}
                        size={"32px"}
                    />
                </div>
            </div>
            <div className="right-side">
                <div className="project-link">
                    <Link
                        to={"/catalog"}
                        state={{ selectedCategories: [374] }}
                        onClick={() => {
                            window.scrollTo(0, 0);
                        }}
                    >
                        <div className="project-img">
                            <img src={mobiledev} alt="Mobile Development" />
                            <div className="overlay">Mobile Development</div>
                        </div>
                    </Link>
                </div>
                <div className="project-link">
                    <Link
                        to={"/catalog"}
                        state={{ selectedCategories: [385] }}
                        onClick={() => {
                            window.scrollTo(0, 0);
                        }}
                    >
                        <div className="project-img">
                            <img src={uxuidesign} alt="UX/UI Design" />
                            <p className="overlay">UX/UI Design</p>
                        </div>
                    </Link>
                </div>
                <div className="project-link">
                    <Link
                        to={"/catalog"}
                        state={{ selectedCategories: [386] }}
                        onClick={() => {
                            window.scrollTo(0, 0);
                        }}
                    >
                        <div className="project-img">
                            <img src={webappdev} alt="Web App Development" />
                            <div className="overlay">Web Development</div>
                        </div>
                    </Link>
                </div>
                <div className="project-link">
                    <Link
                        to={"/catalog"}
                        state={{ selectedCategories: [375] }}
                        onClick={() => {
                            window.scrollTo(0, 0);
                        }}
                    >
                        <div className="project-img">
                            <img src={onlinestores} alt="Online Stores" />
                            <div className="overlay">Online Stores</div>
                        </div>
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default Footer;
